'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'tire';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f631';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm400 0a160 160 0 1 1 -320 0 160 160 0 1 1 320 0z', 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm304 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-40.1 63.5l0 80.3c57.7-3.2 106.3-40.2 126.3-91.6l-76.4-24.9c-9.2 19.4-27.8 33.5-49.9 36.2zm54.9-51.4L395.2 293c3.1-11.8 4.8-24.2 4.8-37 0-45-20.6-85.2-52.9-111.6l-47.2 65c12.4 11.7 20.1 28.2 20.1 46.6 0 4.1-.4 8.2-1.1 12.1zM334.1 135c-22.5-14.6-49.3-23-78.1-23s-55.6 8.5-78.1 23c30.1 41.5 45.8 63.2 47.1 65 9.2-5.1 19.7-8 31-8s21.8 2.9 31 8l47.1-65zm-169.2 9.4c-32.3 26.4-52.9 66.6-52.9 111.6 0 12.8 1.7 25.2 4.8 37l76.4-24.9c-.8-3.9-1.1-8-1.1-12.1 0-18.4 7.7-34.9 20.1-46.6-1.3-1.8-17.1-23.5-47.2-65zm33.2 138.9l-76.4 24.9c20 51.4 68.6 88.4 126.2 91.6l0-80.3c-22.1-2.8-40.7-16.8-49.8-36.2zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;